import { lazy } from 'react';
import { useMfCreatorConfig } from './useMfAdCreatorConfig';

const RemoteAdCreator = lazy(() => import('@modules/remotes/adcreator'));

function AdmModuleAdCreator() {
  const config = useMfCreatorConfig();

  return <RemoteAdCreator {...config} />;
}

export default AdmModuleAdCreator;
